import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () =>(
    <>Page not found!
        <Link to="/">Go home</Link>
    </>
)

export default NotFoundPage;